module.exports = __webpack_public_path__ + "img/wximg18.7373882b.png";